export const getAvailabilitiesUrl = (locationSlug: string) =>
  `/locations/${locationSlug}`;

export const getBookingConfirmationUrl = (
  locationSlug: string,
  bookingId: string
) => `/locations/${locationSlug}/booking/${bookingId}`;

export const getModifyBookingUrl = (locationSlug: string, bookingId: string) =>
  `/locations/${locationSlug}/booking/${bookingId}/modify`;

export const getMenuPageUrl = (locationSlug: string) =>
  `/locations/${locationSlug}/menu`;
